import React from 'react';
import { Row, Col, Table, Tooltip } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWater, faUniversity, faMoneyBillWave, faGlobeAmericas } from '@fortawesome/free-solid-svg-icons'
import { paymentSummaryStripeApi, dateMonthTimeString, getMmmDate } from './utils/ApiUtils';
import { COLORS } from './utils/Constants';

let bankText = "Clicking the above button will take you to a 'Stripe Connected Account' page where you will need to provide details and official documents related to you, your business, and your bank.";
let bankText3 = "These details will help establish your identity and ownership for us to process your movie listing and transfer your share of ticket revenue to your bank.";
let bankText2 = "Please take utmost care in filling out ALL the details.\nPlease complete all the details in one sitting.";
let checkAccountText = "Clicking the above button will take you to a 'Stripe Connected Account' page where you will be able to see all your earnings.";
let supportEmail = "Support Email: hello@hit.movie";
const noteTooltip1 = "Producer share is 70% after taxes.";
const notesText1 = "The revenue from ticket collections is split 70:30 (70 to the Producer and 30 to Hit.Movie).";
const notesText2 = "All amounts are converted to your local currency.";
const notesText3 = "Producers share of revenue (after taxes) is automatically transferred to your connected bank account in all countries except India.";
const notesText4 = "For Indian Producers, share of revenue is transferred manually via NEFT/RTGS.";
const notesText5 = "Producer share of taxes are paid by Hit.Movie, on your behalf, to the respective jurisdictions where tickets are sold.";
const notesText6 = "Revenue numbers shown above may vary to account for charges not captured and refunds if any.";
const notesText62 = "Revenue numbers shown may vary to account for charges not captured and refunds if any.";

export default class RevenueDetails extends React.Component {
  state = {
    tableHeader: [], tableData: [], tableSummary: [], ticketSales: 0, producerShare: 0, producerTax : 0, platformShare: 0, platformTax: 0
  };
  componentDidMount() {
    
  }
  componentDidUpdate() {
    let uploadId = this.props.movieObj.id;
    let currentMovieId = this.state.movieId;
    if((!currentMovieId)||(currentMovieId!==uploadId)) {
      this.setState({ movieId: uploadId });    
      let sessionValue = this.props.sessionValue;
      this.paymentSummary(sessionValue, uploadId);
    }
  }
  paymentSummary = (sessionValue, uploadId) => {
    console.log('paymentSummary sessionValue='+sessionValue);
    if(sessionValue&&uploadId) {
      let toDate = new Date().getTime();
      console.log('toDate='+toDate);
      paymentSummaryStripeApi(sessionValue, uploadId, parseInt(toDate/1000))
      .then(response => {
        console.log('paymentSummary StripeApi data='+JSON.stringify(response));
        if(response.ok) {
          console.log('paymentSummary StripeApi success');
          this.loadTableData(response.info);
        } else {
          console.log('paymentSummary StripeApi  failed');
        }
      })
      .catch((error) => {
        console.log('Error paymentSummary StripeApi='+JSON.stringify(error));
      });
    }
  }
  parseDatewiseSummary = (oldDatesummary) => {
    let updatedSummary = {};
    Object.keys(oldDatesummary).map((keyName, keyIndex) => {
      let dateString = getMmmDate(keyName);
      if(updatedSummary[dateString]) {
        let itemObj = oldDatesummary[keyName];
        Object.keys(itemObj).map((countryName, keyIndex) => {
          if(updatedSummary[dateString][countryName]) {
            let updatedSummaryObj = updatedSummary[dateString][countryName];
            let { ticketsales, platformshare, platformtax, producershare, producertax, paidOriginalAmount } = itemObj[countryName];
            updatedSummaryObj['platformshare'] += platformshare;
            updatedSummaryObj['platformtax'] += platformtax;
            updatedSummaryObj['producershare'] += producershare;
            updatedSummaryObj['producertax'] += producertax;
            updatedSummaryObj['ticketsales'] += ticketsales;
            if(paidOriginalAmount) {
              updatedSummaryObj['paidOriginalAmount'] += paidOriginalAmount;
            }
          } else {
            updatedSummary[dateString][countryName] = itemObj[countryName];
          }
        });
      } else {
        updatedSummary[dateString] = oldDatesummary[keyName];
      }
    });
    return updatedSummary;
  }
  loadTableData = (dataTable) => {
    console.log('loading table');
    if(dataTable&&dataTable.countries) {
      let countriesList = dataTable.countries;
      let dateSummary = dataTable['datewise summary'];
      let currency = dataTable['currency'];
      let totalSummary = dataTable['total payment summary'];
      let ticketSales = 0, producerShare = 0, producerTax = 0, platformShare = 0, platformTax = 0;
      if(totalSummary) {
        ticketSales = totalSummary['total ticket sales'];
        producerShare = totalSummary['total producer share'];
        producerTax = totalSummary['total producer tax'];
        platformShare = totalSummary['total platform share'];
        platformTax = totalSummary['total platform tax'];
      }
      let tableHeaderTemp = [], newDataItems = [];
      let headerItemsSummary = {};
      tableHeaderTemp.push({ title: 'Date', dataIndex: 'date', width: 180, fixed: 'left' });
      countriesList.map((item, index) => {
        console.log('loading table item='+item);
        headerItemsSummary[item] = 0;
        tableHeaderTemp.push({ title: item, dataIndex: item });
      });
      let grandTotal = 0;
      let newDateSummary = this.parseDatewiseSummary(dateSummary);
      tableHeaderTemp.push({ title: 'Total', dataIndex: 'total', width: 120, fixed: 'right' });
      if(newDateSummary) {
        Object.keys(newDateSummary).map((keyName, keyIndex) => {
          console.log('keyName='+keyName+' keyIndex='+keyIndex);
          let tempObj = { key: keyName };
          let summaryTotal = 0, summaryProducerShare = 0, summaryProducerTax = 0, summaryPlatformShare = 0, summaryPlatformTax = 0;
          tempObj['date'] = keyName;
          let itemObj = newDateSummary[keyName];
          let childElements = [{ 'date': 'Producer Share', key: keyIndex+1 }, { 'date': 'Producer Tax', key: keyIndex+2 }, { 'date': 'Platform Share', key: keyIndex+3 }, { 'date': 'Platform Tax', key: keyIndex+4 }];
          Object.keys(itemObj).map((keyName, keyIndex) => {
            console.log('keyName='+keyName+' keyIndex='+keyIndex);
            let { ticketsales, platformshare, platformtax, producershare, producertax, paidOriginalAmount, paidOriginalCurrency } = itemObj[keyName];
            // tempObj[keyName] = ticketsales;
            childElements[0][keyName] = producershare.toFixed(2);
            childElements[1][keyName] = producertax.toFixed(2);
            childElements[2][keyName] = platformshare.toFixed(2);
            childElements[3][keyName] = platformtax.toFixed(2);
            summaryProducerShare += producershare;
            summaryProducerTax += producertax;
            summaryPlatformShare += platformshare;
            summaryPlatformTax += platformtax;
            headerItemsSummary[keyName] += ticketsales;
            if(paidOriginalAmount) {
              tempObj[keyName] = ticketsales.toFixed(2)+' ('+paidOriginalAmount+' '+paidOriginalCurrency+')';  
            } else {
              tempObj[keyName] = ticketsales.toFixed(2);
            }
            summaryTotal += ticketsales;
            console.log('summaryProducerShare='+summaryProducerShare)
          });
          childElements[0]['total'] = summaryProducerShare.toFixed(2);
          childElements[1]['total'] = summaryProducerTax.toFixed(2);
          childElements[2]['total'] = summaryPlatformShare.toFixed(2);
          childElements[3]['total'] = summaryPlatformTax.toFixed(2);
          tempObj['total'] = summaryTotal.toFixed(2);
          tempObj['children'] = childElements;
          grandTotal += summaryTotal;
          newDataItems.push(tempObj);
        });
        headerItemsSummary['bigTotal'] = grandTotal;
        console.log('final data='+JSON.stringify(newDataItems)+' summary='+JSON.stringify(headerItemsSummary));
      }
      this.setState({ tableHeader: tableHeaderTemp, tableData: newDataItems, tableSummary: headerItemsSummary, ticketSales: ticketSales,
        producerShare: producerShare, producerTax : producerTax, platformShare: platformShare, platformTax: platformTax, currency: currency });
    }
  }
  render() {
    let country = this.props.movieObj.legalEntityCountry;
    let { tableHeader, tableData, tableSummary, ticketSales, producerShare, producerTax, platformShare, platformTax } = this.state;
    let isIndia = country==='India';
    let paddingValue = 1;
    let currentDate = Date.now()/1000;
    let accountButton = this.props.isVerified ? 'Check Your Earnings' : 'Setup Bank & KYC';
    let style1 = { height: 44, background: COLORS.greenBG, padding: '8px 0', fontFamily: 'OpenSans-Bold', color: COLORS.whiteFdf9,
        display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' };
    let style2 = { height: 44, background: COLORS.lightgreen, padding: '8px 0', fontFamily: 'OpenSans-Bold', color: COLORS.whiteFdf9,
        display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 16 };
    let style3 = { height: 90, background: COLORS.greenBG, padding: '8px 0', fontFamily: 'OpenSans-Bold', color: COLORS.whiteFdf9,
      display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 16 };
    console.log('uploadId='+this.state.movieUploadId);
    return (
            <div style={{ display: "flex", flexDirection: 'column', height: '100%', marginTop: 60 }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent:'center', alignItems: 'center', marginBottom: 6 }}>
                <FontAwesomeIcon color={COLORS.lightgreen} icon={faMoneyBillWave} style={{ fontSize: 36, marginBottom: 12 }} />
                <p className="Agree" style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', color: COLORS.lightgreen, lineHeight: 1.2, marginBottom: 4 }}>
                  Revenue Summary
                </p>
                <p className="Agree" style={{ fontSize: 14, fontFamily: 'OpenSans-Bold', color: COLORS.lightgreen, lineHeight: 1.2, marginBottom: 0 }}>
                  (as of {dateMonthTimeString(currentDate)})
                </p>
              </div>
              <div>
                <p style={{ float: 'right', fontSize: 13, fontFamily: 'OpenSans-Bold', color: COLORS.greyaaa, lineHeight: 1, marginBottom: 8 }}>
                  All values are in {this.state.currency}
                </p>
              </div>
              <Row gutter={[8, 8]} style={{ backgroundColor: 'white', padding: paddingValue, borderRadius: 3 }}>
                <Col style={{ padding: paddingValue }} className="gutter-row" span={5}>
                  <Tooltip title={notesText62}><div style={style3}>Ticket Sales</div></Tooltip>
                </Col>
                <Col style={{ padding: 0 }} className="gutter-row" span={10}>
                  <Col style={{ padding: paddingValue }} span={24}>
                    <div style={style1}>Producer (70%)</div>
                  </Col>
                  <Row>
                    <Col style={{ padding: paddingValue }} className="gutter-row" span={12}>
                      <Tooltip title={noteTooltip1}>
                        <div style={style1}>Share</div>
                      </Tooltip>
                    </Col>
                    <Col style={{ padding: paddingValue }} className="gutter-row" span={12}>
                      <Tooltip title={notesText5}>
                        <div style={style1}>Tax</div>
                      </Tooltip>
                    </Col>
                  </Row>
                </Col>
                <Col style={{ padding: 0 }} className="gutter-row" span={9}>
                  <Col style={{ padding: paddingValue }} span={24}>
                    <div style={style1}>Hit.Movie Platform (30%)</div>
                  </Col>
                  <Row>
                    <Col style={{ padding: paddingValue }} className="gutter-row" span={12}>
                      <div style={style1}>Share</div>
                    </Col>
                    <Col style={{ padding: paddingValue }} className="gutter-row" span={12}>
                      <div style={style1}>Tax</div>
                    </Col>
                  </Row>
                </Col>   
                <Col style={{ padding: paddingValue }} className="gutter-row" span={5}>
                  <div style={style2}>{ticketSales}</div>
                </Col>
                <Col style={{ padding: paddingValue }} className="gutter-row" span={5}>
                  <div style={style2}>{producerShare}</div>
                </Col>
                <Col style={{ padding: paddingValue }} className="gutter-row" span={5}>
                  <div style={style2}>{producerTax}</div>
                </Col>
                <Col style={{ padding: 0 }} span={9}>
                  <Row>
                    <Col style={{ padding: paddingValue }} className="gutter-row" span={12}>
                      <div style={style2}>{platformShare}</div>
                    </Col>
                    <Col style={{ padding: paddingValue }} className="gutter-row" span={12}>
                      <div style={style2}>{platformTax}</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div style={{height: 60 }} />
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent:'center', alignItems: 'center', marginBottom: 6 }}>
                <FontAwesomeIcon color={COLORS.lightgreen} icon={faGlobeAmericas} style={{ fontSize: 36, marginBottom: 12 }} />
                <p className="Agree" style={{ fontSize: 20, fontFamily: 'OpenSans-Bold', color: COLORS.lightgreen, lineHeight: 1.2, marginBottom: 0 }}>
                  Date & Country-wise Breakup
                </p>
              </div>
              <div>
                <p style={{ float: 'right', fontSize: 13, fontFamily: 'OpenSans-Bold', color: COLORS.greyaaa, lineHeight: 1, marginBottom: 5 }}>
                  All values are in {this.state.currency}. Figures in brackets indicate original currency in which the charge was made.
                </p>
              </div>
              <Table indentSize={16} bordered columns={tableHeader} dataSource={tableData} pagination={false} scroll={{ x: 1300 }}
                summary={pageData => {
                  return (
                    <>
                      <Table.Summary.Row key={'totalKey'}>
                        <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                        { Object.keys(tableSummary).map((keyName, keyIndex) => {
                          return <Table.Summary.Cell index={keyIndex+1} key={keyIndex}>{tableSummary[keyName].toFixed(2)}</Table.Summary.Cell>
                        })
                        }
                      </Table.Summary.Row>
                    </>
                  );
                }} />
              <div style={{ display: isIndia ? 'none' : 'block', height: this.props.isVerified ? 200 : 260 }}>
                <div style={{ width: '100%', height: 60, marginTop: 60, display: 'flex', justifyContent:'center' }}>
                  <div onClick={() => { this.props.openAccountLink() }} style={{ cursor: 'pointer', width: 244, height: 58, background: COLORS.eeeWhite, borderRadius: 5 }}>
                    <Row style={{ width: 240, height: 54, background: COLORS.lightgreen, borderRadius: 3, margin: 2 }}>
                      <div style={{ display: 'flex', alignItems:'center', width: '100%', height: 56, justifyContent:'center' }}>
                        <FontAwesomeIcon color={COLORS.white} icon={faUniversity} style={{ fontSize: 24, marginRight: 8 }} />
                        <div className='col' style={{  }}>
                          <p style={{ color: COLORS.white, fontSize: 18, marginBottom: 0, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>{accountButton}</p>
                        </div>
                      </div>
                    </Row>
                  </div>
                </div>
                <div style={{ width: '80%', marginLeft: '10%' }}>
                  <p className="Agree" style={{ marginTop: 40, fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}>
                    {this.props.isVerified ? checkAccountText : bankText}
                  </p>
                { this.props.isVerified
                  ?
                  <div/>            
                  :
                  <p className="Agree" style={{ whiteSpace: 'break-spaces', fontSize: 13, fontFamily: 'OpenSans-Bold', color: COLORS.redClose, lineHeight: 1.2 }}>
                    {bankText2}<p className="Agree" style={{ fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}>{bankText3}</p>
                  </p>
                }
                </div>
              </div>
              <p className="Agree" style={{ marginTop: 40, fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.redClose, lineHeight: 1.2, marginBottom: 0 }}>
                {supportEmail}
              </p>
              <p className="Agree" style={{ marginTop: 40, fontSize: 13, fontFamily: 'OpenSans-Bold', color: COLORS.greyaaa, lineHeight: 1.2, textAlign: 'left' }}>
                NOTES:
              </p>
              <ol style={{ fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.greyaaa, lineHeight: 1.2 }}>
                <li>
                {notesText1}
                </li>
                <li>
                {notesText2}
                </li>
                <li>
                {notesText3}
                </li>
                <li>
                {notesText4}
                </li>
                <li>
                {notesText5}
                </li>
                <li style={{ color: COLORS.redClose }}>
                {notesText6}
                </li>
                <li>
                Please read related terms <a target='_blank' rel="noopener noreferrer" href='https://docs.hit.movie/services-and-privacy-terms#revenue-share'>here</a>.
                </li>
              </ol>
              <div style={{ display: 'flex', width: '100%', justifyContent:'center' }}>
                <FontAwesomeIcon color={COLORS.blue3a4a5a} icon={faWater} style={{ fontSize: 36, margin: 60 }} />
              </div>
            </div>   
    );
  }
}